import { Link } from 'gatsby'
import React from 'react'
import styles from './AptitudeTest.module.scss'
import JobSeekerHeading from '../JobSeekerHeading'
import PracticeTest from '../PracticeTest'
import data from './data'

const AptitudeTest = () => {
  return (
    <div className={styles.main}>
      <div className={`${styles.container}`}>
        <div className={`${styles.inner} py-3 px-1`}>
          {/* className={styles.section} */}
          <div>
            {/* <h2 className="text-center">
              What Are The Different Types Of Aptitude Test?
            </h2>
            <div>
              <p>
                Broadly speaking there are three types of{' '}
                <Link to="/practice-aptitude-tests">aptitude test</Link>:
              </p>
              <ul>
                <li>
                  <strong>
                    <a rel="nofollow" href="https://l.linklyhq.com/l/J3UH">
                      Verbal reasoning tests
                    </a>
                  </strong>{' '}
                  which assess your ability to understand and interpret written
                  information. Click here for a{' '}
                  <a href="https://tests.practicereasoningtests.com/free-verbal-test?tid1=practice-verbal-test">
                    verbal reasoning practice test
                  </a>
                  .
                </li>
                <li>
                  <strong>
                    <a
                      rel="nofollow"
                      href="https://tests.practicereasoningtests.com/numerical-reasoning"
                    >
                      Numerical reasoning
                    </a>{' '}
                    <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                      tests
                    </a>
                  </strong>{' '}
                  which assess your ability to understand and use numbers. Click
                  here for a{' '}
                  <a href="https://tests.practicereasoningtests.com/free-numerical-test?tid1=practice-numerical-test">
                    numerical reasoning practice test
                  </a>
                  .
                </li>
                <li>
                  <strong>
                    <a rel="nofollow" href="https://l.linklyhq.com/l/JrqQ">
                      Inductive reasoning tests
                    </a>
                  </strong>{' '}
                  (also known as spatial or{' '}
                  <a href="https://tests.practicereasoningtests.com/free-abstract-test?tid1=practice-abstract-reasoning-test">
                    abstract reasoning
                  </a>{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    tests
                  </a>
                  ) which assess your ability to see patterns in data and work
                  flexibly with unfamiliar information. Click here for an{' '}
                  <a href="https://tests.practicereasoningtests.com/free-inductive-reasoning?tid1=practice-inductive-test">
                    inductive reasoning practice test
                  </a>
                  .
                </li>
              </ul>
              <div className={`${styles.videoRresponsive}  my-4 `}>
                <iframe
                  src="https://www.youtube.com/embed/YerFp7SPOE8"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>
            </div> */}
            <PracticeTest />
            <JobSeekerHeading
              title="What Are The Different Types Of Aptitude Assessments?"
              subHeading="These are the most common types of aptitude test that you will encounter:"
            />
            <div className="row p-lg-5 w-100 mx-auto">
              {data.map((e) => {
                return (
                  <div key={e.title} className="col-sm-6">
                    <div className={`${styles.testType} d-flex `}>
                      <div>
                        <img
                          src={e.img}
                          alt={e.title}
                          width="100%"
                          height="100%"
                        />
                      </div>
                      <div>
                        <h3>{e.title}</h3>
                        {e.desc}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className={`${styles.videoRresponsive}  my-4 `}>
            <iframe
              src="https://www.youtube.com/embed/YerFp7SPOE8"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>
          <div className={styles.section}>
            <h2 className="text-center">How to Prepare for an Aptitude Test</h2>
            <div>
              <p>
                Aptitude{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                are designed to be challenging.
              </p>
              <p>
                To ensure that you do as well as you possibly can, there really
                is no substitute for practice.
              </p>
              <p>But don’t waste time practicing more than you need to.</p>
              <p>
                Find out exactly what type of{' '}
                <Link to="/practice-aptitude-tests">aptitude test</Link> you
                will be taking and practice just this type of{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>
                .
              </p>
              <p>
                First use example questions with explained answers to
                familiarise yourself with the types of questions you will be
                asked and then take practice{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                to improve your performance.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2 className="text-center">What Are Aptitude Tests Like?</h2>
            <div>
              <p>
                Aptitude{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                are typically quite short, often less than 15 minutes long, and
                are usually completed online.
              </p>
              <p>
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  Tests
                </a>{' '}
                generally have challenging time limits and often increase in
                difficulty throughout the{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>
                .
              </p>
              <p>
                This is to put the candidate under pressure and try to
                understand what their maximum level of performance is.
              </p>
              <p>
                Typically,{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                present the candidate with some information and ask them to use
                this information to answer a question, usually providing a
                number of possible answers.
              </p>
              <p>
                The more questions the candidate answers correctly within the
                time limit, the better their score will be.
              </p>
              <p>
                While some{' '}
                <Link to="/practice-aptitude-tests">aptitude tests</Link> will
                only focus on one type of thinking (either{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  verbal
                </a>{' '}
                or{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/numerical-reasoning"
                >
                  numerical reasoning
                </a>
                , for example) some will have multiple sections that will{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>{' '}
                various different types of skills.
              </p>
              <p>
                A multi-part assessment such as that will often take about an
                hour to complete.
              </p>
              <p>
                Each section will be roughly 10 to 30 questions, depending on
                how complex each question is on a particular{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>
                .
              </p>
              <p>
                Basically, if there are more complex questions, the assessment
                section will have fewer questions.
              </p>
              <p>
                The position for which the{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>{' '}
                is being given may also determine the complexity and length of
                the assessment, i.e., the higher-level the job, the more
                questions and more complex questions are likely to be asked.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2 className="text-center">How Are Aptitude Tests Marked?</h2>
            <div>
              <p>
                Aptitude{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                are norm referenced.
              </p>
              <p>
                This means that your performance on the{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>{' '}
                will be compared to a “norm group.”
              </p>
              <p>
                A norm group is a group of people with similar characteristics
                to the candidate, a group of graduate trainees for example.
              </p>
              <p>
                Your score will be compared to the scores of the people in the
                norm group, and this will allow the assessor to understand your
                performance relative to others who are similar to you.
              </p>
              <p>Usually, a candidate’s score is expressed as a percentile.</p>
              <p>
                This, then, tells the assessor what percentage of the norm group
                their performance surpassed.
              </p>
              <p>
                If a candidate scored on the 75th percentile, for example, they
                have performed better than 75 percent of the norm group.
              </p>
              <p>
                Each particular employer may have a different performance level
                required for specific positions.
              </p>
              <p>
                To be successful, the candidate must achieve a level of
                performance that exceeds a stated minimum.
              </p>
              <p>
                Candidates will usually not know what the minimum score
                requirement is before they take an{' '}
                <Link to="/practice-aptitude-tests">aptitude test</Link>.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2 className="text-center">Why Are Aptitude Tests Used?</h2>
            <div>
              <p>
                Aptitude{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                are often used by employers as part of a selection process for a
                job.
              </p>
              <p>
                While <Link to="/practice-aptitude-tests">aptitude tests</Link>{' '}
                won’t necessarily{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  test
                </a>{' '}
                candidates on their ability to perform a specific job within a
                company, they will give the employer a general sense of how well
                a candidate can think on their toes and demonstrate
                critical-thinking skills that would be reflective of the type of
                thinking they’ll need to do on the job.
              </p>
              <p>
                Administering{' '}
                <Link to="/practice-aptitude-tests">aptitude tests</Link> allows
                companies to narrow down the number of candidates who have
                applied for a job to a more refined group that may be more
                qualified for the job.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2 className="text-center">When Are Aptitude Tests Used?</h2>
            <div>
              <p>
                Aptitude{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                are most often used before a formal interview and are normally
                conducted online.
              </p>
              <p>
                Employers often use the results of the{' '}
                <a
                  rel="nofollow"
                  href="https://tests.practicereasoningtests.com/shl"
                >
                  tests
                </a>{' '}
                in conjunction with how a candidate has performed in an
                interview to make a final hiring decision.
              </p>
              <p>
                Combined, the two modes of assessment give employers a clearer
                picture of a candidate’s ability.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2 className="text-center">
              How To Pass Aptitude Tests: Our Top 3 Tips
            </h2>
            <div>
              <ol>
                <li>
                  <p role="presentation">
                    Familiarize yourself with common types of questions that you
                    will be asked. For example, numerical{' '}
                    <a
                      rel="nofollow"
                      href="https://tests.practicereasoningtests.com/shl"
                    >
                      tests
                    </a>{' '}
                    often have questions about percentages. Make sure you know
                    how to work these out before your{' '}
                    <a
                      rel="nofollow"
                      href="https://tests.practicereasoningtests.com/shl"
                    >
                      test
                    </a>
                    !
                  </p>
                </li>
                <li>
                  <p role="presentation">
                    If you’re taking an{' '}
                    <Link to="/practice-aptitude-tests">aptitude test</Link>{' '}
                    online make sure you are sitting somewhere quiet where you
                    won’t be disturbed for the duration of the{' '}
                    <a
                      rel="nofollow"
                      href="https://tests.practicereasoningtests.com/shl"
                    >
                      test
                    </a>
                    .
                  </p>
                </li>
                <li>
                  <p role="presentation">
                    When you are taking{' '}
                    <a
                      rel="nofollow"
                      href="https://tests.practicereasoningtests.com/shl"
                    >
                      tests
                    </a>
                    , work quickly but accurately and ensure you take a few
                    seconds to double check you’ve understood the question and
                    that you’ve actually selected the answer you had in mind.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AptitudeTest
